import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, switchMap, take, tap } from 'rxjs';
import { AuthTokensService } from './auth-tokens.service';
import { AuthService } from './auth.service';

export const authenticationGuard: CanActivateFn = () => {
    const _authService = inject(AuthService);
    const _authTokensService = inject(AuthTokensService);
    const _tokensReady$ = toObservable(_authTokensService.tokensReady$);

    const loginNavigation = () =>
        of(false).pipe(
            tap(() => {
                _authTokensService.loginNavigation();
            })
        );

    return _tokensReady$.pipe(
        take(1),
        switchMap(() => {
            return _authService.getUser().pipe(
                map(() => true),
                catchError(() => loginNavigation())
            );
        }),
        catchError(() => loginNavigation())
    );
};
